import React, { memo } from 'react'

import Modal from 'components/Luxkit/Modal/Modal'
import TourV2FinePrint from 'components/OfferPage/TourV2/FinePrint/TourV2FinePrint'

interface Props {
  finePrint: Tours.V2OfferFinePrint;
  title: string;
  onClose: () => void;
  open: boolean;
}

function TourV2FinePrintModal(props: Props) {
  const { finePrint, title, onClose, open } = props

  return (
    <Modal
      title="Trip Fine Print"
      subtitle={title}
      isOpen={open}
      onClose={onClose}
    >
      {!!finePrint && <TourV2FinePrint finePrint={finePrint} />}
    </Modal>
  )
}

export default memo(TourV2FinePrintModal)
